// DTM
import React, { Component } from "react";
import styled from "styled-components";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  padding: 50px 0 25px 0;
  margin: 0 calc(50% - 525px);
  float: left;
  width: 1050px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1100px) {
    position: relative;
    display: block;
    padding: 40px 0 27px 0;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
  @media (max-width: 700px) {
    padding: 0 0 40px 0;
    width: calc(100% - 46px);
    margin: 0 23px;
  }
`;

class SetPress extends Component {
  render() {
    let items = [];
    for (let i in this.props.set) {
      items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        {items.map((item, itemIndex) => (
          <Press content={item} key={itemIndex} />
        ))}
      </Wrapper>
    );
  }
}

export default SetPress;

const Item = styled.div`
  width: 100%;
  margin: 5px 0;
  :nth-child(even) {
    div {
      @media (min-width: 701px) {
        flex-direction: row-reverse;
        background-color: #f9f9f9;
      }
    }
  }
`;
const Title = styled.div`
  font-family: Lato;
  font-size: 27px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: #3949ab;
  width: 100%;
`;
const ContentWrapper = styled.div`
  display: flex;
  @media (max-width: 700px) {
    flex-direction: column;
  }
  @media (min-width: 701px) {
    padding: 10px;
  }
  justify-content: flex-start;
  align-items: flex-start;
`;
const Body = styled.div`
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: rgba(0, 0, 0, 0.85);
  width: 65%;
  @media (max-width: 700px) {
    width: 100%;
    order: 2;
  }
  @media (min-width: 700px) {
    padding: 0 2em;
  }
`;
const Image = styled.img`
  width: calc(35% - 25px);
  margin-left: 25px;
  @media (max-width: 700px) {
    width: 100%;
    margin: 23px 0;
    order: 1;
  }
`;

class Press extends ArticleAbstract {
  showImage() {
    window.location.assign(this.imageUrl());
  }

  render() {
    return (
      <Item {...this.link()}>
        <ContentWrapper>
          <Body>
            <Title>{this.title()}</Title>
            {this.body()}
          </Body>
          <Image src={this.imageUrl()} onClick={this.showImage.bind(this)} />
        </ContentWrapper>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetPress.js